import { createAction, props, union } from '@ngrx/store';

import {
  CasProfile,
  LoginAccessToken,
  LoginPhaseError,
  LoginStep,
  LoginPhaseProfile,
  Profile,
} from '@fcom/core-api/login/interfaces/login.interface';
import {
  AccountSecurityStandaloneAction,
  AccountSecurityStandaloneActionName,
  AccountSecurityFlowActionName,
  AccountSecurityFlowType,
  AccountSecurityFlowAction,
  AccountSecurityFlowData,
} from '@fcom/core-api/login/interfaces/account-security.interface';

export const setAccessToken = createAction('[LoginActions] SetToken', props<{ accessToken: LoginAccessToken }>());
export const clearAccessToken = createAction('[LoginActions] ClearToken');
export const setProfile = createAction('[LoginActions] SetProfile', props<{ profile: Profile }>());
export const setCasProfile = createAction('[LoginActions] SetCasProfile', props<{ casProfile: CasProfile }>());
export const setLoginError = createAction('[LoginActions] Error');
export const setCasLoginError = createAction('[LoginActions] CasError');
export const setNotLoggedIn = createAction('[LoginActions] SetNotLoggedIn');
export const setCasNotLoggedIn = createAction('[LoginActions] SetCasNotLoggedIn');
export const setLoginPhaseExecutionToken = createAction('[LoginActions] SetExecutionToken', props<{ token: string }>());

export const setLoginPhaseStep = createAction('[LoginActions] setLoginPhaseStep', props<{ step: LoginStep }>());
export const setLoginPhaseProfile = createAction(
  '[LoginActions] SetLoginPhaseProfile',
  props<{ profile: LoginPhaseProfile }>()
);
export const setLoginPhaseError = createAction(
  '[LoginActions] setLoginPhaseError',
  props<{ error: LoginPhaseError }>()
);
export const clearLoginPhase = createAction('[LoginActions] clearLoginPhase');

export type SetAccountSecurityStandaloneActionPayload<T extends AccountSecurityStandaloneActionName> = Omit<
  AccountSecurityStandaloneAction<T>,
  'success'
>;

export const setAccountSecurityStandaloneAction = createAction(
  '[LoginActions] setAccountSecurityStandaloneAction',
  props<{
    standaloneAction: {
      [T in AccountSecurityStandaloneActionName]: SetAccountSecurityStandaloneActionPayload<T>;
    }[AccountSecurityStandaloneActionName];
  }>()
);

export type SetAccountSecurityFlowActionPayload<T extends AccountSecurityFlowType> = Omit<
  AccountSecurityFlowAction<T>,
  'success'
>;

export const setAccountSecurityFlowAction = createAction(
  '[LoginActions] setAccountSecurityFlowAction',
  props<
    {
      [T in AccountSecurityFlowType]: {
        flowType: T;
        flowAction: Record<
          AccountSecurityFlowActionName<T>,
          SetAccountSecurityFlowActionPayload<T>
        >[AccountSecurityFlowActionName<T>];
      };
    }[AccountSecurityFlowType]
  >()
);

export const setAccountSecurityFlowData = createAction(
  '[LoginActions] setAccountSecurityFlowData',
  props<
    {
      [T in AccountSecurityFlowType]: {
        flowType: T;
        flowData: AccountSecurityFlowData<T> | null;
      };
    }[AccountSecurityFlowType]
  >()
);

const _all = union({
  setAccessToken,
  clearAccessToken,
  setProfile,
  setLoginError,
  setNotLoggedIn,
  clearLoginPhase,
  setLoginPhaseStep,
  setLoginPhaseProfile,
  setLoginPhaseError,
  setLoginPhaseExecutionToken,
  setCasProfile,
  setCasLoginError,
  setCasNotLoggedIn,
  setAccountSecurityStandaloneAction,
  setAccountSecurityFlowAction,
  setAccountSecurityFlowData,
});

export type LoginActionUnion = typeof _all;
